import React from "react";

import { GetEstadoString } from "../othelloFunciones";
import Grid from "@mui/material/Grid";

import OthelloEdit  from "../componentsothello/OthelloEdit.jsx";
import { TipoPeticion } from "../othelloConstantes";
import OthelloPrimary from "../componentsothello/OthelloPrimary";


function Peticion({...props })
{
    //variables de las propiedas recibidas
    const { idpeticion} = props;   

    const [peticion, setpeticion] = React.useState(null);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {

        var jsonData = JSON.stringify(idpeticion);

        fetch('api/Data/GetPeticion', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: jsonData

        }).then(response => response.json()).then(data => {
            setpeticion(data);
            setLoading(false)
        }).catch(error => {
            setpeticion(null);
            setLoading(false)
        });
    }, [loading]);

    return (
        <>
            <div>           
                {!loading && peticion != null ?
                    <div>
                        <OthelloPrimary><span style={{ fontSize: 15 }}><b>Datos de la Peticion</b></span></OthelloPrimary>
                        {peticion.tipo == TipoPeticion.Establecimiento ?
                            <Grid container>
                                <Grid item xs={6}  >
                                    <OthelloEdit label="Nombre" currentvalue={peticion.establecimiento.nombre} readonly={true} />
                                </Grid>
                                <Grid item xs={6}  >
                                    <OthelloEdit label="Apellido" currentvalue={peticion.establecimiento.apellido} readonly={true} />
                                </Grid>
                                <Grid item xs={6}  >
                                    <OthelloEdit label="EMail" currentvalue={peticion.establecimiento.eMail} readonly={true} />
                                </Grid>
                                <Grid item xs={6}  >
                                    <OthelloEdit label="Telefono" currentvalue={peticion.establecimiento.telefono} readonly={true} />
                                </Grid>
                            </Grid> : ""}
                        {peticion.tipo == TipoPeticion.Establecimiento ?
                            <Grid container>
                                <Grid item xs={12}  >
                                    <OthelloEdit label="Establecimiento" currentvalue={peticion.establecimiento.title} readonly={true} />
                                </Grid>
                                <Grid item xs={12}  >
                                    <OthelloEdit label="Direccion" currentvalue={peticion.establecimiento.footNote} readonly={true} />
                                </Grid>
                                <Grid item xs={6}  >
                                    <OthelloEdit label="Latitud" currentvalue={peticion.establecimiento.latStringAux} readonly={true} />
                                </Grid>
                                <Grid item xs={6}  >
                                    <OthelloEdit label="Longitud" currentvalue={peticion.establecimiento.lonStringAux} readonly={true} />
                                </Grid>
                                <Grid item xs={12}  >
                                    <OthelloEdit label="Descrpcion Breve" currentvalue={peticion.establecimiento.descripcion} readonly={true} rows={3} />
                                </Grid>
                                <Grid item xs={12}  >
                                    <OthelloEdit label="Descrpcion Larga" currentvalue={peticion.establecimiento.descripcionLarga} readonly={true} rows={7} />
                                </Grid>
                            </Grid> : ""}
                        {peticion.tipo == TipoPeticion.Contacto ?
                            <Grid container>
                                <Grid item xs={12}  >
                                    <OthelloEdit label="Nombre" currentvalue={peticion.contacto.nombre} readonly={true} />
                                </Grid>
                                <Grid item xs={6}  >
                                    <OthelloEdit label="EMail" currentvalue={peticion.contacto.eMail} readonly={true} />
                                </Grid>
                                <Grid item xs={6}  >
                                    <OthelloEdit label="Telefono" currentvalue={peticion.contacto.telefono} readonly={true} />
                                </Grid>
                            </Grid> : ""}
                        {peticion.tipo == TipoPeticion.Contacto ?
                            <Grid container>
                                <Grid item xs={12}  >
                                    <OthelloEdit label="Mensaje" currentvalue={peticion.contacto.mensaje} readonly={true} rows={7}/>
                                </Grid>
                            </Grid> : ""}


                    </div>
                    : ""}
            </div>
        </>
    );
}

export default Peticion;